import { forwardRef, type Ref } from 'react';

import { cn } from '#/lib/utils';

type Props = {
  className?: string;
  dataSanity?: string;
  children: React.ReactNode;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span';
};

export const Overline = forwardRef(
  (
    { className, dataSanity, children, as = 'span' }: Props,
    ref: Ref<HTMLHeadingElement | HTMLDivElement>,
  ) => {
    const Tag = as;
    return (
      <Tag
        ref={ref}
        data-sanity={dataSanity}
        className={cn(
          'text-current/90 font-azeret text-11 font-medium uppercase leading-150 tracking-3 m:text-12 m:tracking-5 block',
          className,
        )}
      >
        {children}
      </Tag>
    );
  },
);

Overline.displayName = 'Overline';
